export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export const apiClient = async (url: string, options: RequestInit = {}) => {
    const defaultOptions: RequestInit = {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...((options.headers as any) || {})
        },
    };

    if (options.body instanceof FormData) {
        const headers = defaultOptions.headers as Record<string, string>;
        delete headers['Content-Type'];
    }

    const finalOptions = { ...defaultOptions, ...options };

    try {
        const response = await fetch(url, finalOptions);

        if (response.status === 401) {
            console.warn("Sesión expirada o no autorizada (401). Cerrando sesión...");
            window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
            throw new Error('Unauthorized: Session expired');
        }
        return response;
    } catch (error) {
        throw error;
    }
};